import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { inputShared } from '../shared.vanilla.mjs';

const PrimitiveInput = forwardRef(
  ({ className: classNameFromProps, state, ...props }, forwardedRef) => {
    const className = classNames(inputShared({ state }), classNameFromProps);
    return /* @__PURE__ */ jsx(
      StyledInput,
      {
        className,
        spellCheck: false,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
const StyledInput = styled(Primitive.input);
PrimitiveInput.displayName = "PrimitiveInput";

export { PrimitiveInput };
//# sourceMappingURL=PrimitiveInput.mjs.map
